import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Popover } from '@material-ui/core'
import React from 'react'
import FieldForm from './FieldForm'

function HyperlinkConfiguration({
    open,
    setOpen,
    title="Hyperlink Configuration",
    anchorEl,
    anchorPos,
    action, 
    onClose,
    selectedView, 
    selectedField, 
    parentEntity,
    widgetId 
}) {
    return (
         <Popover
                id={"hyperlink-configuration"}
                open={open}
                anchorReference="anchorPosition"
                anchorPosition = {{ top: anchorPos.top, left: anchorPos.left }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right" // 👈 align popup's right edge to the click point
                }}
            >
                <div style={{width: '300px', maxHeight: '430px'}}>
                    <DialogContent style={{padding: '10px', width: '100%', height: '100%'}} >
                        <h5 style={{marginBottom: '5px'}}>{title}</h5>
                        <Divider />

                        <FieldForm  
                            setShowHyperlinkConfig={setOpen}
                            hyperlinkConfig={true}
                            selectedView={selectedView} 
                            action={"edit"} 
                            widgetId={widgetId} 
                            parentEntity={parentEntity} 
                            onClose={onClose} 
                            selectedField={selectedField}
                        />
                    </DialogContent>
                </div>
            </Popover>
    )
}

export default HyperlinkConfiguration